import {
  ACCESS_TOKEN_EXPIRY,
  REFRESH_TOKEN,
  TOKEN,
} from "../../helper/constant";
import { revokeSession } from "../auth/session.api";
import { logout } from "../Redux/auth/authSlice";
import { useAppDispatch } from "../Redux/utilities";

const useHandleLogout = () => {
  const dispatch = useAppDispatch();

  const handleLogout = (callback?: () => void) => {
    /* Kill the token family server-side so the refresh token is worthless
       even if clearing storage below fails or a copy exists elsewhere.
       Storage is the source of truth here, not redux -- a user logging out
       from the nav has both, and on the session-expired path both are
       already empty because the server has just refused the token anyway. */
    const refreshToken = localStorage.getItem(REFRESH_TOKEN);
    if (refreshToken) revokeSession(refreshToken);

    dispatch(logout());
    /* Leaving the refresh token behind would let the next visitor to this
       browser resume the session the user just ended. 'authless' is the
       key the old easyHttp helper cached the JWT under; clear it for
       anyone who still has one from before this change. */
    localStorage.removeItem(TOKEN);
    localStorage.removeItem(REFRESH_TOKEN);
    localStorage.removeItem(ACCESS_TOKEN_EXPIRY);
    localStorage.removeItem("authless");
    callback && callback();
    window.location.href = process.env.REACT_APP_BASE_WEB_URL ?? '';
  };

  return {
    handleLogout,
  };
};

export default useHandleLogout;
